<div id="icons" class="page-layout simple tabbed" fxLayout="column">
    <!-- CONTENT -->
    <div class="p-24" style="color: red; font-weight: bold; font-size: 28px;">
        {{'Too much opened tabs/windows with application. You should have opened only one tab or window.'|translate}}<br/><br/>
    </div>
</div>
